/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Forced_Subtitle_LabelInputs */

const en_context_menu_forced_subtitle_label = /** @type {(inputs: Context_Menu_Forced_Subtitle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark events as forced subtitle`)
};

const fr_context_menu_forced_subtitle_label = /** @type {(inputs: Context_Menu_Forced_Subtitle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marquer les événements comme sous-titre forcé`)
};

const de_context_menu_forced_subtitle_label = /** @type {(inputs: Context_Menu_Forced_Subtitle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisse als erzwungenen Untertitel markieren`)
};

const it_context_menu_forced_subtitle_label = /** @type {(inputs: Context_Menu_Forced_Subtitle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrassegna gli eventi come sottotitoli forzati`)
};

const ru_context_menu_forced_subtitle_label = /** @type {(inputs: Context_Menu_Forced_Subtitle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отметьте события как обязательные подзаголовки.`)
};

const es_context_menu_forced_subtitle_label = /** @type {(inputs: Context_Menu_Forced_Subtitle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcar eventos como subtítulos forzados`)
};

const zh_cn2_context_menu_forced_subtitle_label = /** @type {(inputs: Context_Menu_Forced_Subtitle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标记事件为强制字幕`)
};

const ja_context_menu_forced_subtitle_label = /** @type {(inputs: Context_Menu_Forced_Subtitle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントを強制字幕としてマークする`)
};

const hi_context_menu_forced_subtitle_label = /** @type {(inputs: Context_Menu_Forced_Subtitle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घटनाओं को अनिवार्य उपशीर्षक के रूप में चिह्नित करें`)
};

const pt_pt2_context_menu_forced_subtitle_label = /** @type {(inputs: Context_Menu_Forced_Subtitle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marque os eventos como legendas obrigatórias.`)
};

/**
* | output |
* | --- |
* | "Mark events as forced subtitle" |
*
* @param {Context_Menu_Forced_Subtitle_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_forced_subtitle_label = /** @type {((inputs?: Context_Menu_Forced_Subtitle_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Forced_Subtitle_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_forced_subtitle_label(inputs)
	if (locale === "de") return de_context_menu_forced_subtitle_label(inputs)
	if (locale === "it") return it_context_menu_forced_subtitle_label(inputs)
	if (locale === "ru") return ru_context_menu_forced_subtitle_label(inputs)
	if (locale === "es") return es_context_menu_forced_subtitle_label(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_forced_subtitle_label(inputs)
	if (locale === "ja") return ja_context_menu_forced_subtitle_label(inputs)
	if (locale === "hi") return hi_context_menu_forced_subtitle_label(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_forced_subtitle_label(inputs)
	return en_context_menu_forced_subtitle_label(inputs)
});